// services/budgetApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ApiReportsResponse,
  GetDisputeStatisticsResponse,
  DisputeData,
  DisputeDetailsData,
} from '../../../types/reports';
import { baseQueryWithReauth } from '../baseQuery';

export const disputeReportsService = createApi({
  reducerPath: 'disputeReportsService',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getDisputeStatistics: builder.query<GetDisputeStatisticsResponse, void>({
      query: () => ({
        url: `/jobs/v1/disputes-report/statistics`,
      }),
    }),
    getDispute: builder.query<ApiReportsResponse<DisputeData>, string>({
      query: (params) => ({
        url: `/jobs/v1/disputes-report?${params}`,
      }),
    }),
    getDisputeById: builder.query<DisputeDetailsData, string>({
      query: (id) => ({
        url: `/jobs/v1/disputes-report/${id}/details`,
      }),
    }),
    exportDispute: builder.query<any, { params: string; format: string }>({
      query: ({ params, format }) => ({
        url: `/jobs/v1/disputes-report/export-${format}?${params}`,
        responseHandler: async (response) => await response.blob(),
      }),
    }),
  }),
});

export const {
  useGetDisputeStatisticsQuery,
  useGetDisputeQuery,
  useGetDisputeByIdQuery,
  useLazyExportDisputeQuery,
} = disputeReportsService;
